import React, { createContext, useCallback, useState, useContext } from 'react';
import PropTypes from 'prop-types';

const SendBatchBriefContext = createContext();

export const SendBatchBriefContextProvider = (({ children }) => {
    const [isBatchBrief, setIsBatchBrief] = useState(false);

    const setSendBatchBrief = useCallback(
        (value) => {
            setIsBatchBrief(value);
        },
        [setIsBatchBrief]
    );

    return (
        <SendBatchBriefContext.Provider value={{ isBatchBrief, setSendBatchBrief }}>
            {children}
        </SendBatchBriefContext.Provider>
    );
});

SendBatchBriefContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export const useBatchBrief = () => useContext(SendBatchBriefContext);
